import React, { FC, useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import Link from 'buyside/components/presentation/Link/link';
import Modal from 'buyside/components/presentation/Modal/modal';
import UserRankingLineChart from 'buyside/components/presentation/Charts/UserRankingLineChart/userRankingLineChart';

import { formatCategoryLabel } from 'buyside/util/rankCategoryHelper';

import { useCurrentUserRankingsQuery } from 'interfaces/graphql-typings';

import styles from '../rankingsIndexPageStyles.scss';

const CurrentUserRankings: FC<{ profileId?: string }> = ({ profileId }) => {
  const [isRankingHistoryOpen, setIsRankingHistoryOpen] = useState(false);

  const { data, loading } = useCurrentUserRankingsQuery();

  const renderOpenModalButton = useCallback(
    () => (
      <Link to="#" onClick={() => setIsRankingHistoryOpen(true)}>
        View Your Ranking History
      </Link>
    ),
    []
  );

  if (loading) return null;

  const currentRanks = data?.currentUser?.currentRanks;

  if (!currentRanks?.length) return null;

  return (
    <div className={styles.currentUserRankings}>
      <label>Your ranked categories</label>
      <div className={styles.pills}>
        {currentRanks.map(rank => {
          if (rank.value === null || rank.value === undefined) return null;

          return (
            <NavLink
              key={`current-user-ranking-${rank.id}`}
              to={`/${rank.category}`}
              className={({ isActive }) => classNames(styles.pill, { [styles.active]: isActive })}
            >
              <strong>#{rank.value + 1}</strong> {formatCategoryLabel(rank.category)}
            </NavLink>
          );
        })}
      </div>
      {profileId ? (
        <Modal
          isOpen={isRankingHistoryOpen}
          onClose={() => setIsRankingHistoryOpen(false)}
          renderOpenModalButton={renderOpenModalButton}
          size="xl"
          title="Your Ranking History"
        >
          <UserRankingLineChart profileId={profileId} />
        </Modal>
      ) : null}
    </div>
  );
};

export default CurrentUserRankings;
